import {$, findTarget} from '../utils/Utils';

/* This script deals with the transition within the left menu
 * and shows the correct menu level on opening
 * if you're after the opening/closing of the menu itself,
 * check menu.js - where the opening/closing for both the desktop and mobile
 * menu is handled.
 */

const menuLeft = (() => {
  const config = {
    menu: $('.js-leftMenu')[0],
    trigger: [...$('.js-leftMenuTrigger')],
    targetCN: 'js-leftMenuTarget',
    expandedCN: '-expanded',
    listItemCN: 'menuLeft__item'
  };

  const toggleMenu = ({ e, trigger }) => {
    e.preventDefault();
    e.cancelBubble = true;
    const subMenu = findTarget({
      element: trigger,
      parent: config.listItemCN,
      target: config.targetCN
    });
    subMenu.classList.toggle(config.expandedCN);
    trigger.classList.toggle(config.expandedCN);
  };

  const build = () => {
    config.trigger.forEach((trigger) => {
      trigger.addEventListener('click', e => toggleMenu({e, trigger}));
    });
  };

  const init = () => {
    if (config.menu) {
      build();
    }
  };

  return {
    init,
  };
})();

export default menuLeft.init();
